import { Header } from '@/components/landing/Header'
import { Hero } from '@/components/landing/Hero'
import { Features } from '@/components/landing/Features'
import { HowItWorks } from '@/components/landing/HowItWorks'
import { Pricing } from '@/components/landing/Pricing'
import { Testimonials } from '@/components/landing/Testimonials'
import { Team } from '@/components/landing/Team'
import { News } from '@/components/landing/News'
import { CTA } from '@/components/landing/CTA'
import { Footer } from '@/components/landing/Footer'
import '@/styles/landing.css'

export function HomePage() {
  return (
    <div className="landing-page">
      <Header />
      <Hero />
      <Features />
      <HowItWorks />
      <Pricing />
      <Testimonials />
      <Team />
      <News />
      <CTA />
      <Footer />
    </div>
  )
}
